import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { blogPosts } from "@/mocks/blog-posts";

export default function BlogPreview() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <section id="blog" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-8">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
          <div className="md:w-1/2">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold tracking-wide mb-3 whitespace-nowrap">
              Latest Articles
            </span>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 leading-tight">
              In-Depth{" "}
              <span className="text-primary-600">ACBuy Spreadsheet</span>{" "}
              Resources &amp; Guides
            </h2>
          </div>
          <div className="md:w-1/2">
            <p className="text-sm text-foreground-600 leading-relaxed">
              Explore our collection of detailed guides, honest reviews, and side-by-side comparisons to help you make the most informed sourcing decisions. Each article is written with real buyer needs in mind.
            </p>
          </div>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
          {blogPosts.map((post) => (
            <Link
              key={post.id}
              to={`/${post.id}`}
              className="group cursor-pointer"
            >
              <div className="rounded-2xl overflow-hidden bg-background-100 hover:bg-background-200/50 transition-colors duration-300 h-full flex flex-col">
                {/* Image */}
                <div className="aspect-[16/10] overflow-hidden">
                  <img
                    src={post.imageUrl}
                    alt={post.title}
                    title={`${post.title} - ACBuy Spreadsheet`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                {/* Content */}
                <div className="p-4 md:p-5 flex flex-col flex-1">
                  <span className="inline-block px-2.5 py-1 rounded-lg bg-accent-100 text-accent-800 text-xs font-medium mb-3 whitespace-nowrap w-fit">
                    {post.category}
                  </span>
                  <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-700 transition-colors line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 flex-1">
                    {post.excerpt}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-500">
                    <span>{post.date}</span>
                    <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                    <span>{post.readTime}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* View All CTA */}
        <div className="text-center mt-10">
          <a
            href="#blog"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-300 text-foreground-800 text-sm font-semibold hover:border-foreground-800 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Browse All Articles
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}